
export const CIDADES_BLOQUEADAS = ['SALTO DA LONTRA'];

export const normaliza = (s: string) =>
  (s || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const cidadeBloqueada = (nome?: string) =>
  CIDADES_BLOQUEADAS.some(b => normaliza(b) === normaliza(nome || ''));
